const ContactsPage = () => {
  return (
    <>
      <h2>Контакты</h2>
    </>
  )
};

export default ContactsPage;